import type { ReactNode } from 'react';

import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title: ReactNode;
  actions?: ReactNode;
}

// Заголовок контентной страницы (h1) с необязательными действиями справа.
export function PageHeader({ title, actions }: PageHeaderProps): JSX.Element {
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
